import React from 'react';
import { Box, Text, WixDesignSystemProvider } from '@wix/design-system';
import { DisplayError } from './common/DisplayError';
export const PmaActionExecutionWidget = _ref => {
  var _data$displayMessage, _data$displayMessage2;
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(WixDesignSystemProvider, {
    features: {
      newColorsBranding: true
    }
  }, data.success && /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    direction: "horizontal",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(AI, null), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "The task was successfully completed.")), !data.success && /*#__PURE__*/React.createElement(DisplayError, {
    message: (_data$displayMessage = data.displayMessage) == null ? void 0 : _data$displayMessage.message,
    cta: (_data$displayMessage2 = data.displayMessage) == null ? void 0 : _data$displayMessage2.cta
  }));
};
export const PMA_ACTION_EXECUTION_WIDGET = 'PMA_ACTION_EXECUTION_WIDGET';
const AI = () => /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_4302_7806",
  maskUnits: "userSpaceOnUse",
  x: "3",
  y: "1",
  width: "53",
  height: "57"
}, /*#__PURE__*/React.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M32.1913 3.03713C25.4368 4.0344 18.2691 7.61495 12.317 13.567C8.74483 17.1392 6.02673 21.1508 4.20867 25.2414L3.06641 24.7337C4.94835 20.4994 7.75524 16.361 11.4331 12.6831C17.556 6.56021 24.9633 2.84076 32.0088 1.80054C39.0542 0.760317 45.7823 2.39842 50.442 7.05814C55.1017 11.7179 56.7398 18.446 55.6996 25.4914C54.6594 32.5368 50.9399 39.9441 44.817 46.067C38.9662 51.9178 31.9441 55.5718 25.1862 56.7932C18.4303 58.0143 11.8966 56.8077 7.10334 52.8705L7.89674 51.9046C12.3409 55.555 18.476 56.7358 24.9639 55.5632C31.4498 54.3909 38.2464 50.8698 43.9331 45.1831C49.8852 39.2311 53.4657 32.0633 54.463 25.3088C55.4603 18.5542 53.8734 12.2573 49.5581 7.94202C45.2428 3.62674 38.9459 2.03985 32.1913 3.03713Z",
  fill: "url(#paint0_angular_4302_7806)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4302_7806)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_4302_7806)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "17.5",
  cy: "45.5",
  r: "15.5",
  fill: "#0021FF"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_4302_7806)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "36",
  cy: "27.5",
  r: "15",
  fill: "#116DFF"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_4302_7806)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "38",
  cy: "5.5",
  r: "14",
  fill: "#5FF2AE"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M8.325 5.425C7.8625 4.9625 7.575 4.3875 7.475 3.75H6.275C6.175 4.3875 5.875 4.9625 5.425 5.425C4.975 5.8875 4.3875 6.175 3.75 6.275V7.475C4.3875 7.575 4.9625 7.875 5.425 8.325C5.8875 8.775 6.175 9.3625 6.275 10H7.475C7.575 9.3625 7.875 8.7875 8.325 8.325C8.775 7.8625 9.3625 7.575 10 7.475V6.275C9.3625 6.175 8.7875 5.875 8.325 5.425Z",
  fill: "#C2E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.375 45C38.0044 45 45 38.0044 45 29.375C45 20.7456 38.0044 13.75 29.375 13.75C20.7456 13.75 13.75 20.7456 13.75 29.375C13.75 38.0044 20.7456 45 29.375 45Z",
  fill: "#C2E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.7875 49.9625C53.1125 49.2875 52.675 48.4375 52.5375 47.5H51.225C51.075 48.4375 50.65 49.3 49.975 49.9625C49.3 50.625 48.45 51.075 47.5125 51.2125V52.525C48.45 52.675 49.3125 53.1 49.975 53.775C50.6375 54.45 51.0875 55.3 51.225 56.2375H52.5375C52.6875 55.3 53.125 54.4375 53.7875 53.775C54.45 53.1125 55.3125 52.6625 56.25 52.525V51.2125C55.3125 51.0625 54.45 50.6375 53.7875 49.9625Z",
  fill: "#C2E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.375 45C38.0044 45 45 38.0044 45 29.375C45 20.7456 38.0044 13.75 29.375 13.75C20.7456 13.75 13.75 20.7456 13.75 29.375C13.75 38.0044 20.7456 45 29.375 45Z",
  fill: "#C2E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8502 31.65C23.7002 29.5 22.3002 26.7625 21.8377 23.75H20.6752C20.2002 26.7625 18.8127 29.5 16.6627 31.65C14.5127 33.8 11.7752 35.2 8.7627 35.6625V36.825C11.7752 37.3 14.5127 38.6875 16.6627 40.8375C18.8127 42.9875 20.2127 45.725 20.6752 48.7375H21.8377C22.3127 45.725 23.7002 42.9875 25.8502 40.8375C28.0002 38.6875 30.7377 37.2875 33.7502 36.825V35.6625C30.7377 35.1875 28.0002 33.8 25.8502 31.65Z",
  fill: "#116DFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.5002 17.5C41.4752 16.475 40.8127 15.175 40.5877 13.75H39.4127C39.1877 15.175 38.5252 16.475 37.5002 17.5C36.4752 18.525 35.1752 19.1875 33.7502 19.4125V20.5875C35.1752 20.8125 36.4752 21.475 37.5002 22.5C38.5252 23.525 39.1877 24.825 39.4127 26.25H40.5877C40.8127 24.825 41.4752 23.525 42.5002 22.5C43.5252 21.475 44.8252 20.8125 46.2502 20.5875V19.4125C44.8252 19.1875 43.5252 18.525 42.5002 17.5Z",
  fill: "#116DFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.75 55C10.1307 55 11.25 53.8807 11.25 52.5C11.25 51.1193 10.1307 50 8.75 50C7.36929 50 6.25 51.1193 6.25 52.5C6.25 53.8807 7.36929 55 8.75 55Z",
  fill: "#116DFF"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_4302_7806",
  x: "0",
  y: "28",
  width: "35",
  height: "35",
  filterUnits: "userSpaceOnUse",
  "color-interpolation-filters": "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  "flood-opacity": "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1",
  result: "effect1_foregroundBlur_4302_7806"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_4302_7806",
  x: "9",
  y: "0.5",
  width: "54",
  height: "54",
  filterUnits: "userSpaceOnUse",
  "color-interpolation-filters": "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  "flood-opacity": "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "6",
  result: "effect1_foregroundBlur_4302_7806"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_4302_7806",
  x: "11",
  y: "-21.5",
  width: "54",
  height: "54",
  filterUnits: "userSpaceOnUse",
  "color-interpolation-filters": "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  "flood-opacity": "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "6.5",
  result: "effect1_foregroundBlur_4302_7806"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular_4302_7806",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.5375 29.3751) scale(26.4625)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.106628",
  "stop-color": "#6F56F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.359375",
  "stop-color": "#116DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.536458",
  "stop-color": "white",
  "stop-opacity": "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.776042",
  "stop-color": "#19D1DF"
}))));
//# sourceMappingURL=PmaActionExecutionWidget.js.map